/* eslint-disable */
export const branchMemberCommitteeCols = [
  {
    title: '职务',
    slot: 'jobType',
    tooltip: true,
    width: 120,
     align: 'center',
  },
  {
    title: '姓名',
    key: 'name',
    tooltip: true,
    width: 150,
     align: 'center',
  },
  {
    title: '分工',
    key: 'jobRange',
    minWidth: 120,
     align: 'center',
  },
  {
    title: '任职时间',
    key: 'startTime',
    width: 140,
    tooltip: true,
     align: 'center',
  },
  {
    title: '支委会是否如期换届',
    slot: 'isNormal',
    width: 180,
     align: 'center',
  },
  {
    title: '备注',
    key: 'remark',
    minWidth: 300,
    align: 'center',
    tooltip: true
  },
  {
    title: '操作',
    slot: 'operation',
    width: 160,
    fixed: 'right',
     align: 'center',
  },
]
export const branchMemberCommitteeForm = {
  attrs: {
    labelWidth: '180px',
    'label-position': 'left',
    rules: {
    },
  },
  items: [
    {
      type: 'select',
      label: '职务',
      prop: 'jobType',
      options: [
        { label: '主委', value: 1 },
        { label: '副主委', value: 2 },
        { label: '委员', value: 3 },
      ],
    },
    {
      label: '姓名',
      prop: 'name',
      maxlength: 20,
      showWordLimit: true,
      clearable: true,
    },
    {
      label: '分工',
      prop: 'jobRange',
      maxlength: 20,
      showWordLimit: true,
      clearable: true,
    },
    {
      type: 'datepicker',
      label: '任职时间',
      prop: 'startTime',
      clearable: true,
      format: 'yyyy-MM',
      dateType: 'month',
    },
    {
      type: 'select',
      label: '支委会是否如期换届',
      prop: 'isNormal',
      options: [
        { label: '否', value: '0' },
        { label: '是', value: '1' },
      ],
    },
    {
      label: '备注',
      prop: 'remark',
      maxlength: 100,
      showWordLimit: true,
      clearable: true,
    },
  ],
}